export default __webpack_public_path__ + "static/media/EcoPlug.5de5b375.jpg";